var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { GridContainer, GridRow, GridCol, getTestId } from '@airtel/air-design-system';
import { BreadcrumbWidget } from '../breadcrumb-widget';
import { ButtonWidget } from '../button-widget';
export var NavbarWidgetComponent = props => {
  var _props$gridRowProps = props.gridRowProps,
    gridRowProps = _props$gridRowProps === void 0 ? {} : _props$gridRowProps,
    _props$breadcrumbWidg = props.breadcrumbWidgetProps,
    breadcrumbWidgetProps = _props$breadcrumbWidg === void 0 ? {} : _props$breadcrumbWidg,
    _props$buttonWidgetPr = props.buttonWidgetProps,
    buttonWidgetProps = _props$buttonWidgetPr === void 0 ? {} : _props$buttonWidgetPr,
    _props$gridColBreadCr = props.gridColBreadCrumbsProps,
    gridColBreadCrumbsProps = _props$gridColBreadCr === void 0 ? {} : _props$gridColBreadCr,
    _props$gridColButtonP = props.gridColButtonProps,
    gridColButtonProps = _props$gridColButtonP === void 0 ? {} : _props$gridColButtonP,
    onUserAction = props.onUserAction,
    testID = props.testID,
    restProps = __rest(props, ["gridRowProps", "breadcrumbWidgetProps", "buttonWidgetProps", "gridColBreadCrumbsProps", "gridColButtonProps", "onUserAction", "testID"]);
  var isButtonWidgetPresent = !!buttonWidgetProps && !!Object.keys(buttonWidgetProps).length;
  return _jsx(GridContainer, Object.assign({}, restProps, getTestId(testID), {
    children: _jsxs(GridRow, Object.assign({}, gridRowProps, {
      children: [_jsx(GridCol, Object.assign({}, gridColBreadCrumbsProps, {
        breakpoints: Object.assign({
          md: isButtonWidgetPresent ? 8 : 12,
          xs: 12
        }, gridColBreadCrumbsProps === null || gridColBreadCrumbsProps === void 0 ? void 0 : gridColBreadCrumbsProps.breakpoints)
      }, {
        children: _jsx(BreadcrumbWidget, Object.assign({}, breadcrumbWidgetProps, {
          onUserAction: onUserAction
        }))
      })), isButtonWidgetPresent && _jsx(GridCol, Object.assign({}, gridColButtonProps, {
        breakpoints: Object.assign({
          md: 4,
          xs: 12
        }, gridColButtonProps === null || gridColButtonProps === void 0 ? void 0 : gridColButtonProps.breakpoints)
      }, {
        children: _jsx(ButtonWidget, Object.assign({}, buttonWidgetProps, {
          onUserAction: onUserAction
        }))
      }))]
    }))
  }));
};
NavbarWidgetComponent.genericRendererKey = 'AirNavbarWidget';